import { render, staticRenderFns } from "./ReportPhysicianActivate.vue?vue&type=template&id=bbbe7522&scoped=true&"
import script from "./ReportPhysicianActivate.vue?vue&type=script&lang=js&"
export * from "./ReportPhysicianActivate.vue?vue&type=script&lang=js&"
import style0 from "./ReportPhysicianActivate.vue?vue&type=style&index=0&id=bbbe7522&lang=scss&scoped=true&"
import style1 from "./ReportPhysicianActivate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbe7522",
  null
  
)

export default component.exports